import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import styled from "styled-components";
import Home from "./pages/Home";
import About from "./pages/About";
import Donate from "./pages/Donate";
import Footer from "./components/Footer";
import LogoImage from "./assets/logo.png"; // Make sure your logo is here

const App = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Router>
      <Header>
        <Nav>
          <LogoContainer>
            <Logo src={LogoImage} alt="Unfamiliar People Logo" />
          </LogoContainer>
          <MenuButton onClick={() => setMenuOpen(!menuOpen)}>☰</MenuButton>
          <NavLinks menuOpen={menuOpen}>
            <StyledLink to="/" onClick={() => setMenuOpen(false)}>Home</StyledLink>
            <StyledLink to="/about" onClick={() => setMenuOpen(false)}>About Us</StyledLink>
            <StyledLink to="/donate" onClick={() => setMenuOpen(false)}>Donate</StyledLink>
          </NavLinks>
        </Nav>
      </Header>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/donate" element={<Donate />} />
      </Routes>

      <Footer />
    </Router>
  );
};

export default App;

// Styled Components
const Header = styled.header`
  width: 100%;
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 5%;
  height: 70px;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  height: 50px;
  width: auto;
`;

const MenuButton = styled.div`
  font-size: 2rem;
  cursor: pointer;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
    position: absolute;
    top: 70px;
    right: 5%;
    background: white;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    display: ${({ menuOpen }) => (menuOpen ? "flex" : "none")};
    padding: 10px;
    border-radius: 5px;
  }
`;

const StyledLink = styled(Link)`
  color: black;
  text-decoration: none;
  font-size: 1.2rem;
  padding: 8px 12px;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: #007BFF;
  }
`;